const backofficeHomeRouter = {
  path: '',
  name: 'backoffice-home',
  component: () => import('../views/HomeView.vue'),
  meta: {
    requiresAuth: true
  }
}

export { backofficeHomeRouter }
